import { ViewContainerRef, Injectable, Injector } from '@angular/core';

import { OverlayRenderer, OverlayConfig } from '../models/tokens';
import { DialogRefStack } from '../models/dialog-ref-stack';
import { vcRefStore } from '../models/vc-ref-store';
import { DialogRef } from '../models/dialog-ref';
import { OverlayContext } from '../models/overlay-context';

const /** @type {?} */ _stack = new DialogRefStack<any>();
export class Overlay {
/**
 * @return {?}
 */
get stackLength(): number {
    return _stack.length;
  }
/**
 * @param {?} _modalRenderer
 * @param {?} injector
 */
constructor(private _modalRenderer: OverlayRenderer, protected injector: Injector) {
  }
/**
 * Check if a given DialogRef is the top most ref in the stack.
 * TODO: distinguish between body modal vs in element modal.
 * @param {?} dialogRef
 * @return {?}
 */
isTopMost(dialogRef: DialogRef<any>): boolean {
    return _stack.indexOf(dialogRef) === _stack.length - 1;
  }
/**
 * @param {?} dialogRef
 * @return {?}
 */
stackPosition(dialogRef: DialogRef<any>) {
    return _stack.indexOf(dialogRef);
  }
/**
 * @param {?} dialogRef
 * @return {?}
 */
groupStackLength(dialogRef: DialogRef<any>): number {
    return _stack.groupLength(_stack.groupOf(dialogRef));
  }
/**
 * Creates an overlay and returns a dialog ref.
 * @template T
 * @param {?} config instructions how to create the overlay
 * @param {?=} group A token to associate the new overlay with, used for reference (stacks usually)
 * @return {?}
 */
open<T extends OverlayContext>(config: OverlayConfig, group?: any): DialogRef<T>[] {
    let /** @type {?} */ viewContainer = config.viewContainer, /** @type {?} */
        containers: Array<ViewContainerRef> = [];

    if (typeof viewContainer === 'string') {
      containers = vcRefStore.getVCRef( /** @type {?} */((viewContainer as string)));
    } else if (Array.isArray(viewContainer)) {
      containers = /** @type {?} */(( viewContainer as any));
    } else if (viewContainer) {
      containers = /** @type {?} */(( [viewContainer] as any));
    } else {
      containers = [null];
    }

    return containers
      .map( vc => this.createOverlay(config.renderer || this._modalRenderer, vc, config, group));
  }
/**
 * @param {?} renderer
 * @param {?} vcRef
 * @param {?} config
 * @param {?} group
 * @return {?}
 */
private createOverlay(renderer: OverlayRenderer,
                        vcRef: ViewContainerRef,
                        config: OverlayConfig,
                        group: any): DialogRef<any> {

    if (config.context) {
      config.context.normalize();
    }

    if (!config.injector) {
      config.injector = this.injector;
    }

    let /** @type {?} */ dialog = new DialogRef<any>(this, config.context || {});
    dialog.inElement = config.context && !!config.context.inElement;

    let /** @type {?} */ cmpRef = renderer.render(dialog, vcRef, config.injector);

    Object.defineProperty(dialog, 'overlayRef', {value: cmpRef});
    _stack.pushManaged(dialog, group);

    return dialog;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OverlayRenderer, },
{type: Injector, },
];
}

function Overlay_tsickle_Closure_declarations() {
/** @type {?} */
Overlay.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Overlay.ctorParameters;
/** @type {?} */
Overlay.prototype._modalRenderer;
/** @type {?} */
Overlay.prototype.injector;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
